import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=b15f5a88&scoped=true&"
import script from "./base-select.vue?vue&type=script&lang=js&"
export * from "./base-select.vue?vue&type=script&lang=js&"
import style0 from "./base-select.vue?vue&type=style&index=0&id=b15f5a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f5a88",
  null
  
)

export default component.exports